import { Controller } from "stimulus"
import { setCookieWithConsent, removeCookieWithDefaultOptions } from "../utils/cookies"
import { Consent } from "../utils/consent"

const showGuiToggle = "SHOW_EXPERIMENTS_GUI"

export default class extends Controller {
  connect() {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const paramValue = urlSearchParams.get(showGuiToggle)

    if (paramValue === "true") {
      setCookieWithConsent(showGuiToggle, "true", Consent.necessary)
    } else if (paramValue === "false") {
      const optionsForRemoval = { path: "/" }
      removeCookieWithDefaultOptions(showGuiToggle, optionsForRemoval)
    }
  }
}
